<script lang="ts">
	import { notificationStore } from '$lib/stores/notifications.svelte';
	import Toast from './Toast.svelte';

	// Get notifications from store
	const notifications = $derived(notificationStore.notifications);

	function handleClose(id: string) {
		notificationStore.remove(id);
	}
</script>

<!-- Render all notifications -->
{#each notifications as notification, index (notification.id)}
	<Toast
		message={notification.message}
		type={notification.type}
		duration={notification.duration}
		onClose={() => handleClose(notification.id)}
		{index}
	/>
{/each}
